'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.form.withInlineEditing.createForm.${key}`;
const Button = ({
  className,
  disabled,
  use,
  onClick
}) => /*#__PURE__*/_jsx(UIButton, {
  className: className,
  size: "sm",
  use: use,
  block: true,
  onClick: onClick,
  disabled: disabled,
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: i18nKey('label')
  })
});
const CreateFormButton = ({
  className = 'm-top-2',
  use = 'tertiary',
  hasPermission = false,
  onClick = () => {}
}) => {
  return /*#__PURE__*/_jsx(UITooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('noWriteAccess')
    }),
    disabled: hasPermission,
    children: /*#__PURE__*/_jsx("div", {
      "data-selenium": "create-resource-button",
      children: /*#__PURE__*/_jsx(Button, {
        className: className,
        use: use,
        onClick: onClick,
        disabled: !hasPermission
      })
    })
  });
};
export default CreateFormButton;